<template>
    <div class="modal fade"
         :id="id"
         tabindex="-1"
         role="dialog"
         :aria-labelledby="id+ 'Title'"
         aria-hidden="true">
        <div :class="'modal-dialog modal-dialog-scrollable modal-dialog-centered ' + lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" :id="id + 'Title'" v-if="title">{{ title }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <slot name="body" :fields="fields"/>
                </div>

                <slot name="footer" :submit="submit" :dismiss="dismiss" :fields="fields">
                    <div class="modal-footer">
                        <button type="button" class="btn btn-white" data-dismiss="modal" @click="dismiss">Close
                        </button>
                    </div>
                </slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                title: this.init_title,
                id: this.init_id,
                fields: this.init_fields,
            };
        },
        props: {
            init_id: {
                type: String,
                default: () => {
                    return this.default.methods.getId();
                }
            },
            init_title: {
                type: String,
                default: () => {
                    return '';
                }
            },
            init_fields: {
                type: Object,
            },
            small_modal: {
                type: Boolean,
                default: () => {
                    return false;
                }
            },
        },
        computed: {
            lg() {
                return this.small_modal ? '' : 'modal-lg';
            },
        },
        methods: {
            makeId() {
                var text = "";
                var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

                for (var i = 0; i < 10; i++)
                    text += possible.charAt(Math.floor(Math.random() * possible.length));

                return text;
            },
            getId() {
                return this.id ? this.id : 'modal_' + this.makeId();
            },
            submit(method, url) {
                let self = this
                self.$store.commit('clearValidationError');
                axios[method](url, this.fields)
                    .then((response) => {
                        self.toggle();
                        self.$store.commit('setNotification', response.data.msg);
                    })
                    .catch((error) => {
                        console.log(error.response.status);
                        if (error.response.status == '422') {
                            self.$store.commit('setValidationError', error.response.data.errors)
                        } else {
                            self.$store.commit('setError', error.response.data.msg)
                        }
                    })
            },
            dismiss() {
                this.fields = this.init_fields;
            },
            toggle() {
                $('#' + this.id).modal('toggle');
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Modal/Modal.vue